import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MapPin, Mail, FileText } from 'lucide-react';
import useSEO, { SEO_CONFIG } from '@/hooks/useSEO';
import BeerCard, { AVAILABILITY_MESSAGE } from '@/components/BeerCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Gamme() {
  const [beers, setBeers] = useState([]);
  const [loading, setLoading] = useState(true);

  useSEO(SEO_CONFIG.gamme);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        setBeers(response.data.filter((p) => !p.is_bundle));
      } catch (error) {
        // erreur de chargement silencieuse
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl text-foreground/60">Chargement...</p>
      </div>
    );
  }

  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <h1 className="text-5xl lg:text-6xl font-heading text-foreground mb-4">Notre gamme de bières artisanales</h1>
          <p className="text-lg text-foreground/70">
            Des bières de caractère, brassées à Saint-Rémy-de-Provence, au cœur des Alpilles.
          </p>
        </div>

        {/* Bandeau disponibilité */}
        <div className="bg-secondary border border-border rounded-2xl p-6 mb-16" data-testid="availability-banner">
          <p className="text-foreground/80">{AVAILABILITY_MESSAGE}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {beers.map((beer) => (
            <BeerCard key={beer.id} beer={beer} />
          ))}
        </div>

        {/* CTA global */}
        <div className="mt-20 bg-secondary border border-border rounded-2xl p-10 text-center">
          <h2 className="text-3xl font-heading text-foreground mb-4">Envie de déguster nos bières ?</h2>
          <p className="text-foreground/70 mb-8 max-w-2xl mx-auto">
            Retrouvez Soif de Provence chez nos revendeurs, lors de nos événements ou en vente directe à la brasserie.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/points-de-vente">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6" data-testid="cta-points-de-vente">
                <MapPin className="w-5 h-5 mr-2" />
                Trouver un point de vente
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="rounded-full px-8 py-6 border-2" data-testid="cta-contact">
                <Mail className="w-5 h-5 mr-2" />
                Nous contacter
              </Button>
            </Link>
            <Link to="/professionnels">
              <Button variant="outline" className="rounded-full px-8 py-6 border-2" data-testid="cta-devis-pro">
                <FileText className="w-5 h-5 mr-2" />
                Demander un devis (professionnels)
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
